import { getTokenFromLocalStorage } from "../utils/local-storage";
const authExist = getTokenFromLocalStorage();

export const headers = {
  "Content-Type": "application/json",
  authorization: `Token ${authExist} `,
};
